export const numberMixin = {
  methods: {
    formatCurrency(amount) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(amount);
    },
    decimalNumberToOnlyTwoDigits(value) {
      const input = value.toString();
      let result = input.replace(/\.(\d{1,2}).*$/, '.$1');
      return parseFloat(result);
    },
  },
};
